(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/quickplay/assets/javascripts/quickplay.js') >= 0) return;  svs.modules.push('/widgets/quickplay/assets/javascripts/quickplay.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.quickplay = svs.widget.quickplay || {};
  svs.widget.quickplay.init = svs.content.bannerTypeQuickplay.init;
})(svs);

 })(window);